import { contactClass as CC, contactType as CT, type FieldType, type IClientContact } from '@/interfaces'

export class ClientContact implements IClientContact {
	[key: string]: FieldType
	id: string
	active: boolean = true
	email?: string
	phone1?: string
	phone2?: string
	mobile?: string
	fax?: string
	firstName?: string
	middleName?: string
	lastName?: string
	position?: string
	title?: string
	address?: string
	type: CT = CT.AP_Billing
	contactClass?: CC = CC.Other
	notes?: string
	recId: number
	constructor({
		id = '',
		email,
		phone1,
		phone2,
		mobile,
		fax,
		firstName,
		middleName,
		lastName,
		position,
		title,
		address,
		active = true,
		notes,
		type = CT.AP_Billing,
		contactClass = CC.Other,
		recId = 0
	}: Partial<IClientContact> = {}) {
		this.id = id
		this.email = email
		this.phone1 = phone1
		this.phone2 = phone2
		this.mobile = mobile
		this.fax = fax
		this.firstName = firstName
		this.middleName = middleName
		this.lastName = lastName
		this.position = position
		this.title = title
		this.address = address
		this.active = active
		this.notes = notes
		this.type = type
		this.contactClass = contactClass
		this.recId = recId
	}
	public get isPrimary(): boolean {
		return this.contactClass === CC.Primary
	}
	public set isPrimary(value: boolean) {
		this.contactClass = value ? CC.Primary : undefined
	}
	public get emailGroupCode(): string {
		switch (this.type) {
			case CT.Purchasing:
				return 'ClientPurchasing'
			case CT.AP_Billing:
				return 'ClientAP'
			case CT.Client:
				return ''
		}
	}
}
